import { useContext, useState, useEffect } from "react";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const BookingPromoPage = ({ end }) => {

	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere} = personalization_state
	const [firstStepReady, setFirstStepReady] = useState(false);
	
	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, bookingPromoPage: false}))
		startHere.set((p) => ({ ...p, show: true}))
		setFirstStepReady(false)
	}
	
	const steps = [
		{
			target: '.promoBookingFirstStep',
			title: "Create Booking Promo",
			content: 'Start creating promo page.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.promoBookingSecondStep',
			title: "Choose Template",
			content: 'Select a design template.',
			disableBeacon: true,
			placement: "bottom",
			path: '/campaign/promo?type=service&step=template'
		},
		{
			target: '.promoBookingThirdStep',
			title: "Customize Template",
			content: 'Customize selected template.',
			disableBeacon: true,
			placement: "bottom",
			action: {
				key: 'TEMPLATE_PROMO_PAGE',
			}
		},
		{
			target: '.promoBookingFourthStep',
			title: "Edit Content",
			content: 'Edit page content here.',
			disableBeacon: true,
			placement: "right",
			path: '/campaign/promo/service/customization?step=1',
			action: {
				key: 'TEMPLATE_PROMO_PAGE_DISABLED',
			}
		},
		{
			target: '.promoBookingFifthStep',
			title: "Style Page",
			content: 'Adjust page styles.',
			disableBeacon: true,
			placement: "right"
		},
		{
			target: '.promoBookingSixthStep',
			title: "Page Details",
			content: 'Edit / Input promo details.',
			disableBeacon: true,
			placement: "right"
		},
		{
			target: '.promoBookingSeventhStep',
			title: "Save Page",
			content: 'Save your booking promo page.',
			disableBeacon: true,
			placement: "bottom"
		},
		{
			target: '.promoBookingEightStep',
			title: "Post Page",
			content: 'Publish your booking promo page.',
			disableBeacon: true,
			placement: "bottom"
		},
	];
	
	useEffect(() => {
		const interval = setInterval(() => {
			const el = document.querySelector('.promoBookingFirstStep');
			if (el) {
				clearInterval(interval);
				setFirstStepReady(true);
			}
		}, 100);
		return () => clearInterval(interval);
	}, []);

	return (
		firstStepReady &&
		<JoyrideWrapper 
			run={Boolean(walkthrough.data.bookingPromoPage)} 
			steps={steps} 
			setter={endTour} 
			end={end}
			p_name="bookingPromoPage" 
			featureName="campaign"
			disableScrolling={true}
		/>
	);
}
